const fixedFilterOptions = [
  {
    id: 'ACTIVITY_NAME',
    type: 'text',
    name: 'Name',
    isUserAdded: false,
  },
  {
    id: 'DATE_RANGE',
    type: 'date',
    name: 'Date Range',
    isUserAdded: false,
  },
  {
    id: 'CREDIT_RANGE',
    type: 'credit',
    name: 'Credit',
    isUserAdded: false,
  },
  {
    id: 'PAIRING_LENGTH',
    type: 'numberRange',
    name: 'Length',
    isUserAdded: false,
  },
  {
    id: 'REPORT_TIME',
    type: 'timeRange',
    name: 'Report',
    isUserAdded: false,
  },
  {
    id: 'RELEASE_TIME',
    type: 'timeRange',
    name: 'Release',
    isUserAdded: false,
  },
];

export default fixedFilterOptions;
